import { StorageKeys } from "@/config/consts";

export class LocaleService {
  /**
   * @description Sets default locale (if not defined)
   */
  public static init() {
    if (!this.getLocale()) {
      LocaleService.setDefault();
    }
  }
  public static setDefault() {
    const defaultLocale = process.env.VUE_APP_I18N_LOCALE || "ru";
    LocaleService.setLocale(defaultLocale);
    return defaultLocale;
  }
  public static setLocale(locale = "") {
    localStorage.setItem(StorageKeys.LOCALE, locale);
  }
  public static getLocale() {
    const result = localStorage.getItem(StorageKeys.LOCALE);
    if (!result) return LocaleService.setDefault();
    return result;
  }
  public static getTranslatedLocale() {
    const result = LocaleService.getLocale();
    if (result == "kk") return "kz";
    return result;
  }
  public static get languages() {
    return ["ru", "kk"];
  }

  /**
   * @description Extracts translated string from given object
   * based on the current locale. kk is translated to kz
   */
  public static parseObject(o: Dictionary) {
    const locale = LocaleService.getTranslatedLocale();
    const objectKey = Object.keys(o).find(key => {
      const lower = key.toLowerCase();
      return lower.substr(lower.lastIndexOf("_")).includes(locale);
    });

    if (!objectKey) return;
    return o[objectKey] as string;
  }
}
